
export enum OfferType {
  fiveChats = 'FiveChats',
  threeChats = 'ThreeChats',
  oneChatAndGems = 'OneChatAndGems',
  hiddenFiveChats = 'HiddenFiveChats',
  oneCheapChat = 'OneCheapChat'
}
